import { Inertia, Method } from '@inertiajs/inertia';
import { Link } from '@inertiajs/inertia-react'
import moment, { duration } from 'moment';
import React, { useContext, useEffect, useState } from 'react'
import route from 'ziggy-js'
import usePageProps from '../hooks/usePageProps';
import Icon from '../Icon';
import { ScreenContext } from '../ScreenContext';
import { TaskType } from '../Types/TaskType';
import { TrackingType } from '../Types/TrackingType';
import { UserType } from '../Types/UserType';

interface Props { }


let timeout;
let reload_interval;

function Footer(props: Props) {
    const { } = props

    const {isMobile} = useContext(ScreenContext)
    const { user, task, current_tracking, current_task } = usePageProps<{ user: UserType, task?: TaskType, current_tracking?: TrackingType, current_task: TaskType }>();

    const [tracked, settracked] = useState(duration());

    const task_duration = duration((task?.total) ?? '00:00:00');

    const count = () => {

        const current_task_duration = duration((current_task?.total) ?? '00:00:00');

        if (current_tracking) {
            let now = moment();
            let start = moment(current_tracking.created_at);
            settracked(duration(now.diff(start)).add(current_task_duration))
        }

        timeout = setTimeout(() => {
            count();
        }, 1000);
    }


    useEffect(() => {
        if(timeout)
            clearTimeout(timeout);

        count();
    }, [current_task])


    useEffect(() => {
      reload_interval = setInterval(() => {
        Inertia.reload({only: ['current_task', 'current_tracking'], preserveScroll: true, preserveState: true});
      }, 10000);
    
      return () => {
        clearInterval(reload_interval);
      }
    }, [])
    

    

    const z = (num) => {
        return num < 10 ? `0${num}` : num;
    }

    return (
        <footer className={`w-full h-100px flex justify-between items-center p-40px pl-200px pr-130px sticky bottom-0 left-0 bg-white/0 backdrop-blur-md  z-99999 mob:px-20px ${isMobile && 'safe'}`}>
            <div className='font-medium text-16'>
                {
                    current_task
                        ? <Link href={route('tasks.show', { task: current_task.id })}>{current_task.name}</Link>
                        : (
                            task
                                ? <Link href={route('tasks.show', { task: task.id })}>{task.name}</Link>
                                : "Choose a task to track"
                        )
                }
            </div>
            <div className='flex gap-30px items-center'>
                <div className='text-16 font-medium'>
                    {
                        current_tracking
                            ? `${z(Math.floor(tracked.asHours()))}:${z(tracked.minutes())}:${z(tracked.seconds())}`
                            : `${z(Math.floor(task_duration.asHours()))}:${z(task_duration.minutes())}:${z(task_duration.seconds())}`
                                
                    }
                </div>
                {current_tracking && <Link as="button" href={route('trackings.end')} method={Method.POST} only={['user', 'current_tracking', 'current_task', 'errors', 'task']} className='bg-red rounded-full h-60px w-60px flex items-center justify-center font-bold text-18 text-white'>
                    <Icon name="pause" />
                </Link>}
                {(!current_tracking && task) && <Link as="button" href={route('trackings.start', { task: task.id })} method={Method.POST} only={['user', 'current_tracking', 'current_task', 'errors', 'task']} className='bg-blue-700 rounded-full h-60px w-60px flex items-center justify-center text-white'>
                    <Icon name="play" />
                </Link>}
                {(!current_tracking && !task) && <Link as="button" href={route('trackings.start', { task: 0 })} method={Method.POST} only={['user', 'current_tracking', 'current_task', 'errors', 'task']} className='bg-blue-700 rounded-full h-60px w-60px flex items-center justify-center text-white'>
                    <Icon name="play" />
                </Link>}
            </div>
        </footer>
    )
}

export default Footer
